/**
 * Help Icon Button Component
 * Small icon button that opens help dialog when clicked
 */

import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { HelpOutline as HelpIcon } from '@mui/icons-material';
import HelpDialog from './HelpDialog';
import { helpContent, HelpContent } from '../config/helpContent';

interface HelpIconButtonProps {
    helpKey: string;
    title: string;
    size?: 'small' | 'medium' | 'large';
}

const HelpIconButton: React.FC<HelpIconButtonProps> = ({ 
    helpKey, 
    title,
    size = 'small'
}) => {
    const [open, setOpen] = useState(false);
    
    const content: HelpContent = helpContent[helpKey] || {
        description: 'No help available for this field.'
    };

    return (
        <>
            <Tooltip title="Click for help">
                <IconButton
                    size={size}
                    onClick={() => setOpen(true)}
                    sx={{ 
                        ml: 0.5,
                        color: 'primary.main',
                        '&:hover': {
                            bgcolor: 'primary.50'
                        }
                    }}
                >
                    <HelpIcon fontSize={size} />
                </IconButton>
            </Tooltip>
            
            <HelpDialog
                open={open}
                onClose={() => setOpen(false)}
                title={title}
                content={content}
            />
        </>
    );
};

export default HelpIconButton;
